import React from 'react';
import FloatingToolbar from '../ui/FloatingToolbar';

interface VehicleOwnerToolbarProps {
  onAddModification: () => void;
  onImportModifications: () => void;
  onEnhanceModifications?: () => void;
  onEditVehicle: () => void;
  onSettings: () => void;
  showEnhance?: boolean;
}

export const VehicleOwnerToolbar: React.FC<VehicleOwnerToolbarProps> = ({
  onAddModification,
  onImportModifications,
  onEnhanceModifications,
  onEditVehicle,
  onSettings,
  showEnhance = false,
}) => (
  <FloatingToolbar
    actions={[
      {
        id: 'add-mod',
        label: 'Add part',
        variant: 'primary',
        onClick: onAddModification,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        ),
      },
      {
        id: 'import-mods',
        label: 'Import build list',
        title: 'Import build list',
        variant: 'secondary',
        onClick: onImportModifications,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        ),
      },
      ...(showEnhance && onEnhanceModifications
        ? [
            {
              id: 'enhance-mods',
              label: 'Improve existing parts',
              title: 'Improve existing parts',
              variant: 'secondary' as const,
              onClick: onEnhanceModifications,
              icon: (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
              ),
            },
          ]
        : []),
      {
        id: 'edit-vehicle',
        label: 'Edit vehicle',
        title: 'Edit vehicle',
        variant: 'secondary',
        onClick: onEditVehicle,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        ),
      },
      {
        id: 'settings',
        label: 'Settings',
        title: 'Build settings',
        variant: 'muted',
        onClick: onSettings,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        ),
      },
    ]}
  />
);
